<template>
  <v-btn @click="handleSupportClick" v-if="!authStore.user.impersonating">
    <v-icon icon="mdi-support_agent" />
    &nbsp; Support Zugang
  </v-btn>

  <v-text-field v-if="showInput" v-model="loginEmail" clearable width="300px" @click:clear="handleSupportClick"
    @keydown.enter="handleLogin" />

  <v-btn v-if="loginEmail" @click="handleLogin">
    <v-icon icon="mdi-login" />
  </v-btn>

  <v-btn v-if="authStore.user.impersonating" @click="handleLogout">
    Logout Support
    <v-icon icon="mdi-logout" />
  </v-btn>
</template>

<script setup>
import { useAuthStore } from "@/stores/authStore";
import { ref } from "vue";

const authStore = useAuthStore();
const loginEmail = ref("");
const showInput = ref(false);

function handleSupportClick() {
  if (authStore.superUser.includes(authStore.user.email)) {
    showInput.value = !showInput.value;
  }
}

function handleLogin() {
  console.log("handle Login", loginEmail);

  authStore.impersonate(loginEmail.value);
}

function handleLogout() {
  console.log("handle Logout");
  authStore.logoutImpersonate();
}
</script>
